

import React, { memo } from 'react';

import AddonView from '../../AddonView/AddonView';








function SupersizeMyEditAddonView({
  addon,
  addonType,
  getSupersizeMyEdits,
  isAddonDescriptionWrapped
}) {
  const createViewItem = () => {
    const supersizeMyEditAddons = getSupersizeMyEdits({ [addonType]: [addon] });

    const { captionValue: { prefix, label, value }, title } = supersizeMyEditAddons[0];

    if (!value) return null;

    return {
      iconName: prefix,
      text: title,
      subText: label,
      price: addon.cost
    };
  };

  const viewItem = createViewItem();

  return viewItem &&
  <AddonView
    isDescriptionWrapped={isAddonDescriptionWrapped}
    {...viewItem} />;


}

export default memo(SupersizeMyEditAddonView);